<template>
    <one-column-layout :title="PRODUCT_NAME2" :fixed="false">
        <template v-slot:top>
            <CustomTourHeader/>
        </template>
        <template v-slot:header>
            <Header/>
        </template>
        <template>
            <div id="partiOra" class="p-2 bg-white mb-2 text-center" v-if="resultMessage">
                <span class="text-primary">{{resultMessage}}</span>
            </div>
            <div>
                <div class="row no-gutters mb-3" :style="isMobile? 'margin-top: 130px' : ''">
                    <div class="col-7 col-md-9 filter-panel">
                        <div class="filter-control">
                            <div class="d-flex justify-content-between"  @click="onOpenCloseFilter">
                                <div>
                                    <a href="javascript:void(0)" class="text-secondary"><b>{{isMobile? 'Filtra' : 'Filtra risultati'}}</b><span> | {{counter}}</span></a>
                                </div>
                                <div>
                                    <button class="btn btn-sm btn-secondary mr-2" @click="onResetFilter">reset</button>
                                </div>
                            </div>
                            <div @mouseleave="openFilter = false">
                                <DropdownFilterTour v-show="openFilter" :min-price="minPrice" :max-price="maxPrice" :value="filter" @change="onChangeFilter"/>
                            </div>
                        </div>
                    </div>
                    <div class="pl-3 col-5 col-md-3">
                        <CustomOrderSelect class="lg gray" :list="orders" :value="order" @change="onChangeOrder" />
                    </div>
                </div>
                <div>
                    <div v-for="(item, index) in tours" :key="index" class="mb-3" ref="listRef">
                        <HorizzontalItemTour :aereoporti="aereoporti" :value="item" @select="onSelect"/>
                    </div>
                </div>
            </div>
        </template>
    </one-column-layout>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DefaultLayout from './layout/DefaultLayout'
import Header from '../widgets/pages/tour-accompagnati/layout/Header'
import WizzardVoloHotel from '../widgets/pages/volo-hotel/WizzardVoloHotel'
import TotalePreventivo from '../widgets/common/TotalePreventivo'
import Itinerario from '../widgets/pages/volo-hotel/Itinerario'
import FilterMainTourPanel from '../widgets/pages/tour-accompagnati/FilterMainTourPanel'
import CustomOrderSelect from '../widgets/common/CustomOrderSelect'
import OneColumnLayout from './layout/OneColumLayout'
import {toDateFromServer} from '../../utils/formatter'
import HorizzontalItemTour from '../widgets/common/tours/HorizontalItemTour'
import {isDateInPeriod} from '../../utils/helper'
import DropdownFilterTour from '../widgets/pages/tour-accompagnati/dropdown/DropdownFilterTour'
import {defaultFiltererTour, defaultSorterTour} from '../../utils/tourUtils'
import TourAccompagnatiSearcher from '../searcher/TourAccompagnatiSearcher'
import {SEARCH_TOUR_LIMIT} from '../../utils/config'
import MobileDetector from '../common/MobileDetector'
import ContentUtils from '../utils/ContentUtils'

export default {
  name: 'TourSelection',
  components: {DropdownFilterTour, HorizzontalItemTour, OneColumnLayout, CustomOrderSelect, FilterMainTourPanel, Itinerario, TotalePreventivo, WizzardVoloHotel, Header, DefaultLayout},
  mixins: [TourAccompagnatiSearcher, MobileDetector, ContentUtils],
  data: function () {
    return {
      openFilter: false,
      tourSelected: null,
      camere: [{adults: 2, childs: []}],
      sort: null,
      orders: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'},
        {name: 'partenza', dir: 'up'},
        {name: 'partenza', dir: 'down'}
      ]
    }
  },
  computed: {
    filter () {
      return this.getToursFilter()
    },
    order () {
      return {name: 'prezzo', dir: this.getOrder()['prezzo']}
    },
    list () {
      return this.getTourList().filter(item => {
        if (item.mini) return false
        if (!item.config || item.config.isDisabilitato) return false
        const search = this.getSearch()
        const departureDates = item.element.departuresDatePrice.map(item => {
          return toDateFromServer(item.date.date)
        })
        if (search.partenza) {
          const fromDate = this.$moment(search.partenza).toDate()
          const toDate = this.$moment(search.partenza).add(SEARCH_TOUR_LIMIT, 'days').toDate()
          return departureDates.some(departureDate => isDateInPeriod(departureDate, {start: fromDate, end: toDate}))
        }
        return true
      })
    },
    aereoporti () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    },
    tours () {
      return this.list.filter(this.filterer).sort(this.sorter)
    },
    counter () {
      return this.tours.length
    },
    prices () {
      return this.list.map(item => {
        return this.getItemMinPrice(item)
      })
    },
    minPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.min(totale, current)
      }) : 0
    },
    maxPrice () {
      return this.prices && this.prices.length > 0 ? this.prices.reduce((totale, current) => {
        return Math.max(totale, current)
      }) : 0
    }
  },
  methods: {
    ...mapGetters(['getTypesAereoporti', 'getTours', 'getSearch', 'getTourList', 'getToursFilter', 'getToursOrder']),
    ...mapActions(['loadingStart', 'loadingEnd', 'addTour', 'modifyTourOrder', 'modifyTourFilter', 'resetTourFilter']),
    getItemMinPrice (item) {
      if (!item.element.departuresDatePrice) return 0
      return item.element.departuresDatePrice.map(item => item.price.importo).reduce((totale, current) => {
        return Math.min(totale, current)
      })
    },
    resetFilter () {
      this.resetTourFilter()
    },
    getOrder () {
      return this.getToursOrder()
    },
    filterer (item) {
      const filter = this.getToursFilter()
      return defaultFiltererTour(item, filter)
    },
    sorter (a, b) {
      const order = this.getOrder()
      return defaultSorterTour(a, b, order)
    },
    onSelect (tour) {
      this.searchAllTourAccompagnati(tour)
    },
    onOpenCloseFilter () {
      this.openFilter = !this.openFilter
    },
    onChangeOrder (order) {
      this.modifyTourOrder({[order.name]: order.dir})
    },
    onChangeFilter (filter) {
      this.modifyTourFilter(filter)
    },
    onResetFilter (event) {
      event.stopPropagation()
      this.resetFilter()
      this.openFilter = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/TourSelection.vue